import Vue from 'vue';
import Vuex from 'vuex';
import Components from './modules/components/index.js'

export const UPDATE_PLOTER_CONFIG = 'updatePloterCongig'
export const UPDATE_STAGE_DATA = 'updateStageData'
export const UPDATE_STAGE_SIZE = 'updateStageSize'
export const UPDATE_STAGE_ELEMENTS = 'updateStageElements'
export const UPDATE_PLOTER_STAGE = 'updatePloterStage'

Vue.use(Vuex);
const key = "user";
const isLogin = "isLogin";
const store = new Vuex.Store ({
// state
 state : {
    nowThemeInfo: 'theme', //当前主题
    themes: ['theme1', 'theme2'] ,//所有主题
    ishome: true, //判断是否是主页,防止其他页面触发监听浏览器分辨率变化
    user: null,
    isLogin: 'FALSE',
    // 当前登录用户有权菜单路由集合（来自 /resource/menuTree，持久化 localStorage，供路由守卫校验）
    menuPaths: (function () { try { return localStorage.getItem('isLogin') === 'TRUE' ? JSON.parse(localStorage.getItem('menuPaths') || '[]') : []; } catch (e) { return []; } })(),
    // 本次会话菜单是否已从 /resource/menuTree 加载完成（路由守卫据此区分「未就绪」与「已加载」，避免用陈旧 localStorage 值误杀）
    menuReady: false,
    //-----plot 开始 ----------
    ploterCfg: {
        readOnly: false,
        businessShape: {
            enable: true,
              requestLoop: 0 // 0为不轮询
        }
    },
    stageData: null,
    stageSize: {
        width: 800,
        height: 600
    },
    stageElements: null,
    ploterStage: null,
    //-----plot 结束 ----------
    listPagePars: new Map(), //查询页的查询条件
},

// 同步操作
 mutations : {
    SAVE_LIST_PAGE_PARS: (state, { path, pars }) => {
      state.listPagePars.set(path, pars);
    },
    RESET_LIST_PAGE_PERS: (state) => {
      state.listPagePars = new Map();
    },


    SET_THEMEINFO(state, theme){
	    state.nowThemeInfo = theme;
    },
    SET_ISHOME(state, is){
        state.ishome = is
    },
    $_setLogin(state, value) {
      state.isLogin = value;
      localStorage.setItem(isLogin, value);
    },
    SET_MENU_PATHS(state, value) {
        state.menuPaths = value;
        try { localStorage.setItem('menuPaths', JSON.stringify(value)); } catch (e) {}
    },
    SET_MENU_READY(state, value) {
        state.menuReady = value;
    },
    $_setStorage(state, value) {
        state.user = value;
        localStorage.setItem(key, JSON.stringify(value));
    },
    $_removeStorage(state) {
        state.user = null;
        state.isLogin = "FALSE";
        state.menuPaths = [];
        state.menuReady = false;
        localStorage.removeItem(key);
        localStorage.removeItem(isLogin);
        localStorage.removeItem('menuPaths');
    },
    //-----plot 开始 ----------
    [UPDATE_PLOTER_CONFIG]: (state, payload) => {
        state.ploterCfg = payload
    },
    [UPDATE_STAGE_DATA]: (state, payload) => {
        state.stageData = payload
    },
    [UPDATE_STAGE_SIZE]: (state, payload) => {
        state.stageSize = payload
    },
    [UPDATE_STAGE_ELEMENTS]: (state, payload) => {
        state.stageElements = payload
    },
    [UPDATE_PLOTER_STAGE]: (state, payload) => {
        state.ploterStage = payload
    }
    //-----plot 结束 ----------
},
 getters : {
    ishome :(state) => state.ishome,
    getStorage: function(state) {
        if(!state.user){
            state.user = JSON.parse(localStorage.getItem(key));
            state.isLogin = localStorage.getItem(isLogin);
        }
        return state.user;
    },
    getMenuPaths: function(state) {
        return state.menuPaths;
    },
    getMenuReady: function(state) {
        return state.menuReady;
    },
    //-----plot 开始 ----------
    ploterConfig: state => state.ploterCfg,
    wrapStageData: state => state.stageData,
    stageSize: state => state.stageSize,
    stageElements: state => state.stageElements,
    ploterStage: state => state.ploterStage
    //-----plot 结束 ----------
},
actions:{
  saveListPagePars: ({ commit }, { path, pars }) => {
    commit('SAVE_LIST_PAGE_PARS', { path, pars });
  }
},
//-----plot 开始 ----------
 modules : {
    ...Components
}
})
//-----plot 结束 ----------

// const store = () => {
//     return new Vuex.Store({
//         state,
//         mutations,
//         getters,
//         modules
//     });
// };

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js